/*
*  -insert desc here-
*
* Copyright (C) 2018, 2019 Sterilis Solutions, LLC, all rights reserved.
*/
import React from 'react';
import { withTranslation as translate} from "react-i18next";
import {Button, Header, Modal, TransitionablePortal} from "semantic-ui-react";
import * as Sentry from "@sentry/browser";
import SimpleLoader from "../../../SimpleLoader";
import AuthService from "../../../AuthService";

const Auth = new AuthService();

class UnbanCustomerModal extends React.Component {
  state = {
    modalLoading: false,
    allowModalToBeClosed: true,
  };
  unbanCustomer = () => {
    const {
      customer
    } = this.props;
    this.setState({
      modalLoading: true,
      allowModalToBeClosed: false,
    });
    const customerID = customer['id'];

    Auth.fetch(`/api/customer/${customerID}/`, {
      method: 'PATCH',
      body: JSON.stringify({
        banned: false
      })
    }).then(data => {
      this.setState({
        modalLoading: false,
        allowModalToBeClosed: true,
      }, () => {
        this.props.preparePage();
        this.props.triggerUnbanCustomerModal(null);
        this.props.notifySuccess('re-activated', 'customer', data['customer_name'])
      });
    }).catch(err => {
      Sentry.captureException(err);
      this.setState({
        modalLoading: false,
        allowModalToBeClosed: true,
      }, () => {
        this.props.triggerUnbanCustomerModal(null);
        this.props.notifyFailure()
      });
    });
  };

  render() {
    const {
      t,
      customer
    } = this.props;
    const {
      modalLoading
    } = this.state;

    const customerName = customer['customer_name'];

    const inlineStyle = {
      modal: {
        // marginTop: topMargin,
        marginTop: '0px !important',
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      textArea: {
        marginTop: '50px',
        width: '400px'
      }
    };
    return (
      <TransitionablePortal
        open={this.props.unbanCustomerModal}
        onOpen={() => setTimeout(() => document.body.classList.add('modal-fade-in'), 0)}
        transition={{animation: 'scale', duration: 500}}
      >
        <Modal
          style={inlineStyle.modal}
          open={true}
          closeOnDimmerClick={this.state.allowModalToBeClosed}
          closeIcon={<Button className='close-modal-btn grey-btn'>{t('Close')}</Button>}
          size='small'
          onClose={(event) => {
            document.body.classList.remove('modal-fade-in');
            this.props.triggerUnbanCustomerModal(null)
          }}
        >
          <Header>
            <h2 className='light-green'>{t('Reactivate Customer')}</h2>
          </Header>
          {modalLoading ? (
            <SimpleLoader/>
          ) : null}
          <Modal.Content>
            <div className='short-modal-text center-text'>
              <p>Are you sure you want to re-activate <strong>{customerName}</strong>?</p>
              <p>Their devices will be able to communicate with the portal. Their users will also be able to log back
                onto the portal.</p>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button className='green-btn'
                    value="Submit"
                    type="submit"
                    id='unbanCustomerBtn'
                    onClick={this.unbanCustomer}
            >{t('Reactivate Customer')}</Button>
          </Modal.Actions>
        </Modal>
      </TransitionablePortal>
    )
  }
}

export default translate('translations')(UnbanCustomerModal);
